import { Image } from "antd";
import { useTranslation } from "react-i18next";
import { CustomButton } from "../../../../components";
import { copyText, middleEllipsis } from "../../../../plugins/utils";
import styles from "./style.module.scss";

const InviteArea = ({ data }) => {
  const { t } = useTranslation();

  const inviteEnum = [
    {
      key: 0,
      title: t("share.inviteArea.code"),
      invite: data?.code,
      showQrCode: false,
      code: data?.code,
    },
    {
      key: 1,
      title: t("share.inviteArea.link"),
      invite: middleEllipsis({
        inputString: data?.invurl,
        minStringLength: 20,
        firstLetterLength: 11,
        secondLetterLength: 6,
      }),
      showQrCode: false,
      code: data?.invurl,
    },
    {
      key: 2,
      title: t("share.inviteArea.scan"),
      invite: data?.qrCode,
      showQrCode: true,
      code: data?.invurl,
    },
  ];

  return (
    <div className={styles.inviteArea}>
      <div className={styles.title}>
        <div>{t("share.inviteArea.title")}</div>
      </div>
      <div className={styles.content}>
        {inviteEnum.map((item, index) => {
          return (
            <div className={styles.block} key={index}>
              <div className={styles.invitation}>{item.title}</div>
              <div className={styles.container}>
                {item.showQrCode ? (
                  <div className={styles.qrCode}>
                    <Image src={item.invite} alt="qrCode" preview={false} width={120} />
                  </div>
                ) : (
                  <div className={styles.invite}>{item.invite} </div>
                )}
                <CustomButton
                  buttonStyle={styles.customButtonStyle}
                  onClick={() => copyText(item.code)}
                >
                  {t("normal.copy")}
                </CustomButton>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InviteArea;
